<template>
  <v-col>
    <v-card-title class="pl-0 pb-0">Retrieve Username</v-card-title>
    <v-form>
      <v-text-field
        type="email"
        label="Email Address"
        v-model="email"
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
      ></v-text-field>
      <v-btn type="submit" color="primary" tile @click.prevent="retrieveUsername" :disabled="this.$v.$invalid? true:false">
        <v-progress-circular
        indeterminate
        color="#fff" v-if="retrieveRequest">
        </v-progress-circular>
        {{buttonText}}
      </v-btn>
      <v-btn color="info" tile class="ml-4" to="/">Back</v-btn>
    </v-form>
    <br />
  </v-col>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import axios from './../../axios'
export default {
  data() {
    return {
      retrieveRequest:false,
      buttonText:'Retrieve Username',
      email: null
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be a valide email.");
      !this.$v.email.required && errors.push("The email is required.");
      return errors;
    }
  },
  methods:{
      retrieveUsername(){
        this.retrieveRequest = true
        this.buttonText = ' Please wait...'
            const formData = {
                email: this.email,
            };
          axios.post('retrieve-username', formData)
            .then(response=>{
              this.retrieveRequest=false
              this.buttonText = 'Retrieve Username'
              this.$store.dispatch('setAlert', response.data.message)
              this.$router.push('/')
            })
            .catch(error=>{
              this.$store.dispatch('setErrorAlert', error.response.data)
              this.retrieveRequest=false
              this.buttonText = 'Retrieve Username'
            })
      }
  }
};
</script>